import { Environment } from '../../const/environment';
import { ICorpusData } from '../../models/ICorpusData';
import { IProject } from '../../models/IProject';
import { IScript } from '../../models/IScript';
import { ITransformRow } from '../../models/ITransform';
import { TransformsFilters } from '../../models/TransformsFilters';
import { IPromiseParam } from '../base';
import * as types from './actionTypes.projects';
import { IReconnectProjectParam, IRememberProjectEnvironmentParam, IChangeEnvironmentParam, IUpdateScriptsParam, IReadLogsParam, IImportFilesParam, IClearChatAndDialogParams, ISaveWakeWordParam, IGetWakeWordsParam, IDeleteWakeWordParam, IMarkLogsAsReadParam, ISendIntentParam, ISetProjectOptionsParam } from './saga.projects';

export const requestListOfProjects = () => ({
    type: types.GET_PROJECTS_REQ
});

export const getPredefinedProjects = ({ sluVersion, resolve, reject }) => ({
    type: types.GET_PREDEFINED_PROJECTS_REQ,
    sluVersion,
    resolve,
    reject
});

export const addNewProject = ({ projectName, sluVersion, resolve, reject }) => ({
    type: types.ADD_PROJECT_REQ,
    projectName,
    sluVersion,
    resolve,
    reject
});

export const addNewProjectByTemplate = ({ name, sluVersion, scripts, projects, tryMessage, isEmpty, resolve, reject }) => ({
    type: types.ADD_PROJECT_BY_TEMPLATE_REQ,
    name,
    sluVersion,
    scripts,
    projects,
    tryMessage,
    isEmpty,
    resolve,
    reject
});

export const deleteProject = (projectId) => ({
    type: types.DELETE_PROJECT_REQ,
    projectId: projectId
});

export const renameProject = ({ projectId, name, resolve, reject }) => ({
    type: types.RENAME_PROJECT_REQ,
    projectId, name, resolve, reject
});

export const resetProjectOnUi = (resolve, reject) => ({
    type: types.RESET_PROJECT_ON_UI_REQ,
    resolve,
    reject
});

export const getProjectInfo = ({ projectId, environment, resolve, reject }) => ({
    type: types.GET_PROJECT_INFO_REQ,
    projectId,
    environment,
    resolve,
    reject
});


export const getProject = ({ projectId, environment, resolve, reject }) => ({
    type: types.GET_PROJECT_REQ,
    projectId,
    environment,
    resolve,
    reject
});

export const reorderProjects = ({ projects }) => ({
    type: types.REORDER_PROJECTS_REQ,
    projects
});

export const reconnectProject = ({ projectId, environment }: IReconnectProjectParam) => ({
    type: types.RECONNECT_PROJECT_REQ,
    projectId,
    environment
});

export const getScripts = (projectId, tagId) => ({
    type: types.GET_SCRIPTS_REQ,
    projectId,
    tagId
});

export const createScript = ({ projectId, tagId, scripts, scriptType }) => ({
    type: types.CREATE_SCRIPT_REQ,
    projectId,
    tagId,
    scripts,
    scriptType
});


export const importFiles = ({ project, files, importMode, environment }: IImportFilesParam) => ({
    type: types.IMPORT_FILES_REQ,
    project,
    files,
    importMode,
    environment
});

export const updateScripts = ({ project, environment, resolve, reject }: IUpdateScriptsParam) => ({
    type: types.UPDATE_SCRIPTS_REQ,
    project,
    environment,
    resolve,
    reject
});

export const updateScript = (project, script, environment) => ({
    type: types.UPDATE_SCRIPT_REQ,
    project,
    script,
    environment,
    manually: true
});

export const renameScript = ({ projectId, tagId, scriptId, name, isCurrent }) => ({
    type: types.RENAME_SCRIPT_REQ,
    projectId,
    tagId,
    scriptId,
    name,
    isCurrent
});

export interface IExportScriptParam {
    script: IScript;
}

export const exportScript = ({ script }: IExportScriptParam) => ({
    type: types.EXPORT_SCRIPT_REQ,
    script,
});

export interface IDuplicateScriptParam {
    projectId: string;
    tagId: string;
    scriptName: string;
    script: IScript;
}

export const duplicateScript = ({ projectId, tagId, script, scriptName }: IDuplicateScriptParam) => ({
    type: types.DUPLICATE_SCRIPT_REQ,
    projectId,
    tagId,
    script,
    scriptName
});

export const deleteScript = ({ project, scriptId, isCurrent }) => ({
    type: types.DELETE_SCRIPT_REQ,
    project,
    scriptId,
    isCurrent
});

export const discardScriptChanges = ({ script }) => ({
    type: types.DISCARD_SCRIPT_CHANGES_REQ,
    script
});

export const reorderScripts = ({ projectId, tagId, scripts }) => ({
    type: types.REORDER_SCRIPTS_REQ,
    projectId,
    tagId,
    scripts
});

export const reorderConversations = ({ projectId, tagId, conversationIds }) => ({
    type: types.REORDER_CONVERSATIONS_REQ,
    projectId,
    tagId,
    conversationIds
});

export const addProjectTag = ({
    project,
    tagName,
    environment,
    runVersionOnProd,
    runVersionOnTesting,
    resolve,
    reject
}) => ({
    type: types.ADD_PROJECT_TAG_REQ,
    project,
    tagName,
    environment,
    runVersionOnProd,
    runVersionOnTesting,
    resolve,
    reject
});

export const setProjectTag = ({ project, tagId, environment, checkForUnsaved }) => ({
    type: types.SET_UP_PROJECT_TAG_REQ,
    project,
    tagId,
    environment,
    checkForUnsaved
});

export const renameTag = (project, tagId, tagName, environment) => ({
    type: types.RENAME_PROJECT_TAG_REQ,
    project,
    tagId,
    tagName,
    environment
});

export const deleteTag = (project, tagId, environment) => ({
    type: types.DELETE_PROJECT_TAG_REQ,
    project,
    tagId,
    environment
});

export const changeEnvironment = ({ project, environment }: IChangeEnvironmentParam) => ({
    type: types.CHANGE_SERVER_TYPE_REQ,
    project,
    environment
});

export const makeScriptsEditable = (project, tagId, lastTagId) => ({
    type: types.MAKE_SCRIPTS_EDITABLE_REQ,
    project,
    tagId,
    lastTagId
});

export const disconnectFromProject = () => ({
    type: types.DISCONNECT_PROJECT_REQ,
});

export const sendIntent = ({ text, resolve, reject }: ISendIntentParam) => ({
    type: types.SEND_INTENT_REQ,
    text, resolve, reject
});

export const sendMessage = (text) => ({
    type: types.SEND_MESSAGE_PROJECT_REQ,
    text
});

export const clearChatMessages = () => ({
    type: types.CLEAR_CHAT_MESSAGES
});

export const clearChatAndDialog = ({ project, environment }: IClearChatAndDialogParams) => ({
    type: types.CLEAR_CHAT_AND_DIALOG_REQ,
    project, environment
});

export const reloadProject = () => ({
    type: types.RELOAD_PROJECT_REQ,
});

export const resetProject = (resolve, reject) => ({
    type: types.RESET_PROJECT_REQ,
    resolve,
    reject
});

export const setProjectOptions = ({
    project,
    options,
    environment,
    cohorts,
    selectedCohortId,
    resolve,
    reject
}: ISetProjectOptionsParam) => ({
    type: types.SET_PROJECT_OPTIONS_REQ,
    project,
    options,
    environment,
    cohorts,
    selectedCohortId,
    resolve,
    reject
});

export const exportDialogs = ({ project, script, filters, environment, resolve, reject }) => ({
    type: types.EXPORT_DIALOGS_REQ,
    project,
    script,
    filters,
    environment,
    resolve,
    reject
});

export const exportLogs = ({ project, script, filters, environment, resolve, reject }) => ({
    type: types.EXPORT_LOGS_REQ,
    project,
    script,
    filters,
    environment,
    resolve,
    reject
});

export const readLogs = ({ project, script, filters, environment, onlyActiveFilters, filterUpdateTs, resolve, reject }: IReadLogsParam) => ({
    type: types.READ_LOGS_REQ,
    project,
    script,
    filters,
    environment,
    onlyActiveFilters,
    filterUpdateTs,
    resolve,
    reject
});

export const getAnalyticsIntents = ({ projectId, filters, environment, fromDate, toDate, dialogIds, resolve, reject }) => ({
    type: types.GET_ANALYTICS_INTENTS_REQ,
    projectId,
    filters,
    environment,
    fromDate,
    toDate,
    dialogIds,
    resolve,
    reject
});

export const getProjectStatisticsByRange = ({ projectId, environment, range, showTopLocations }) => ({
    type: types.GET_PROJECT_STATISTICS_BY_RANGE_REQ,
    projectId,
    environment,
    range,
    showTopLocations
});

export interface IGetResourceUsagePerProjectParam extends IPromiseParam {
    projectId: string,
    environment: Environment
}
export const getResourceUsagePerProject = ({ projectId, environment, resolve, reject }: IGetResourceUsagePerProjectParam) => ({
    type: types.GET_RESOURCE_USAGE_PER_PROJECT_REQ,
    projectId,
    environment,
    resolve,
    reject
});

export const getProjectStatisticsByDates = ({ projectId, environment, fromDate, toDate, resolve, reject }) => ({
    type: types.GET_PROJECT_STATISTICS_BY_DATES_REQ,
    projectId,
    environment,
    fromDate,
    toDate,
    resolve,
    reject
});

export const getProjectStatisticsMinMaxDates = ({ project, resolve, reject }) => ({
    type: types.GET_PROJECT_STATISTICS_MIN_MAX_DATES_REQ,
    project,
    resolve,
    reject
});

export const getProjectLocationStatisticsByDates = ({ projectId, environment, fromDate, toDate }) => ({
    type: types.GET_PROJECT_LOCATION_STATISTICS_BY_DATES_REQ,
    projectId,
    environment,
    fromDate,
    toDate,
});

export const rememberProjectEnvironment = ({ projectId, environment }: IRememberProjectEnvironmentParam) => ({
    type: types.REMEMBER_PROJECT_ENVIRONMENT_REQ,
    projectId,
    environment
});


export const openTestConversation = ({ project, conversationName, resolve, reject }) => ({
    type: types.OPEN_TEST_CONVERSATION_REQ,
    project,
    conversationName,
    resolve,
    reject
});

export const createTestConversation = ({ projectId, name, resolve, reject }) => ({
    type: types.CREATE_TEST_CONVERSATION_REQ,
    projectId,
    name,
    resolve,
    reject
});

export const getTestConversations = ({ projectId, resolve, reject }) => ({
    type: types.GET_TEST_CONVERSATIONS_REQ,
    projectId,
    resolve,
    reject
});

export const getTestConversation = ({ projectId, conversationId }) => ({
    type: types.GET_TEST_CONVERSATION_REQ,
    projectId,
    conversationId
});

export const updateTestConversation = ({ projectId, conversationId, name, resolve, reject }) => ({
    type: types.UPDATE_TEST_CONVERSATION_REQ,
    projectId,
    conversationId,
    name,
    resolve,
    reject
});

export const deleteTestConversation = ({ projectId, conversationId, resolve, reject }) => ({
    type: types.DELETE_TEST_CONVERSATION_REQ,
    projectId,
    conversationId,
    resolve,
    reject
});

export const exportTestConversations = ({ project, resolve, reject }) => ({
    type: types.EXPORT_TEST_CONVERSATIONS_REQ,
    project,
    resolve,
    reject
});

export const importTestConversations = ({ project, conversations, resolve, reject }) => ({
    type: types.IMPORT_TEST_CONVERSATIONS_REQ,
    project,
    conversations,
    resolve,
    reject
});

export const changeProjectTestMode = ({ projectId, mode, projectName, scriptName }) => ({
    type: types.CHANGE_PROJECT_TEST_MODE_REQ,
    projectId,
    projectName,
    scriptName,
    mode
});
export const sendProjectQrCode = () => ({
    type: types.SEND_PROJECT_QR_CODE_REQ,
});

export const markLogsAsRead = ({ projectId, environment, log, filters, filterUpdateTs }: IMarkLogsAsReadParam) => ({
    type: types.MARK_LOGS_AS_READ_REQ,
    projectId,
    environment,
    log,
    filters,
    filterUpdateTs
});

export const showFullCommands = ({ commandInfo, commands, openPanel }) => ({
    type: types.SHOW_MORE_INFO_ABOUT_COMMANDS_REQ,
    commandInfo,
    commands,
    openPanel
});

export const showFullVisualState = ({ visualStateInfo, visualStateIndex }) => ({
    type: types.SHOW_MORE_INFO_ABOUT_VISUAL_STATE_REQ,
    visualStateInfo,
    visualStateIndex
});

export const applyVisualStateInDebugChat = ({ visualState }) => ({
    type: types.APPLY_VISUAL_STATE_IN_DEBUG_CHAT_REQ,
    visualState
});

export const getButtonOptions = ({ projectId, resolve, reject }) => ({
    type: types.GET_BTN_OPTIONS_REQ,
    projectId,
    resolve,
    reject
});

export const addButtonOptions = ({ projectId, name, options, resolve, reject }) => ({
    type: types.ADD_BTN_OPTIONS_REQ,
    projectId,
    name,
    options,
    resolve,
    reject
});

export const updateButtonOptions = ({ projectId, id, name, options, resolve, reject }) => ({
    type: types.UPDATE_BTN_OPTIONS_REQ,
    projectId,
    id,
    name,
    options,
    resolve,
    reject
});

export const deleteButtonOptions = ({ projectId, id, resolve, reject }) => ({
    type: types.DELETE_BTN_OPTIONS_REQ,
    projectId,
    id,
    resolve,
    reject
});



export const getStripePaymentIntent = ({ amount, resolve, reject }) => ({
    type: types.GET_STRIPE_PAYMENT_INTENT_REQ,
    amount,
    resolve,
    reject
});

export const proceedStripePayment = ({ stripePaymentIntentId, refund, nextPlanId, resolve, reject }) => ({
    type: types.PROCEED_STRIPE_PAYMENT_REQ,
    stripePaymentIntentId,
    refund,
    nextPlanId,
    resolve,
    reject
});

export const changePaymentMethod = ({ planId, paymentType, paymentMethod, resolve, reject }) => ({
    type: types.CHANGE_PAYMENT_METHOD_REQ,
    planId,
    paymentType,
    paymentMethod,
    resolve,
    reject
});

export const deletePaymentMethod = ({ paymentMethodId, resolve, reject }) => ({
    type: types.DELETE_PAYMENT_METHOD_REQ,
    paymentMethodId,
    resolve,
    reject
});

export const sendBillingToken = ({ token, resolve, reject }) => ({
    type: types.SEND_BILLING_TOKEN_REQ,
    token,
    resolve,
    reject
});

export const createPaypalOrder = ({ amount, resolve, reject }) => ({
    type: types.CREATE_PAYPAL_ORDER_REQ,
    amount,
    resolve,
    reject
});

export const checkIsPaypalOrderApproved = ({ orderId, resolve, reject }) => ({
    type: types.CHECK_IS_PAYPAL_ORDER_APPROVED_REQ,
    orderId,
    resolve,
    reject
});

export const applyPromoCode = ({ promoCode, resolve, reject }) => ({
    type: types.APPLY_PROMO_CODE_REQ,
    promoCode,
    resolve,
    reject
});


export const getLogImage = ({ projectId, requestId, date, environment, resolve, reject }) => ({
    type: types.GET_LOG_IMAGE_REQ,
    projectId,
    requestId,
    date,
    environment,
    resolve,
    reject
});

export const showBigLogImage = ({ url }) => ({
    type: types.SHOW_BIG_LOG_IMAGE_REQ,
    url
});

export const saveVisualState = ({ projectId, environment, visualState }) => ({
    type: types.SAVE_VISUAL_STATE_REQ,
    projectId,
    environment,
    visualState
});

export const showVisualStatePanel = () => ({
    type: types.SHOW_VISUAL_STATE_PANEL_REQ,
});

export const hideVisualStatePanel = () => ({
    type: types.HIDE_VISUAL_STATE_PANEL_REQ,
});

export const selectVisualState = ({ visualStateTs }) => ({
    type: types.SELECT_VISUAL_STATE_REQ,
    visualStateTs
});

export const saveAuthData = ({ project, environment, authData }) => ({
    type: types.SAVE_AUTH_DATA_REQ,
    project,
    environment,
    authData
});

export const showAuthDataPanel = () => ({
    type: types.SHOW_AUTH_DATA_PANEL_REQ,
});

export const hideAuthDataPanel = () => ({
    type: types.HIDE_AUTH_DATA_PANEL_REQ,
});

export const getTextToSpeach = ({ text, voice, resolve, reject }) => ({
    type: types.GET_TEXT_TO_SPEACH_REQ,
    text,
    voice,
    resolve,
    reject
});

export const uploadAlanBtnLogo = ({ projectId, platform, files, resolve, reject }) => ({
    type: types.UPLOAD_ALAN_BTN_LOGO_REQ,
    projectId,
    platform,
    files,
    resolve,
    reject
});

export const getCohorts = ({ projectId, resolve, reject }) => ({
    type: types.GET_COHORTS_REQ,
    projectId,
    resolve,
    reject
});

export const createCohort = ({ project, environment, cohorts, resolve, reject }) => ({
    type: types.CREATE_COHORT_REQ,
    project,
    environment,
    cohorts,
    resolve,
    reject
});

export const updateCohort = ({ cohort, projectId, environment, resolve, reject }) => ({
    type: types.UPDATE_COHORT_REQ,
    cohort,
    projectId,
    environment,
    resolve,
    reject
});

export const deleteCohort = ({ cohort, projectId, environment, resolve, reject }) => ({
    type: types.DELETE_COHORT_REQ,
    cohort,
    projectId,
    environment,
    resolve,
    reject
});

export const searchLocationsForCohort = ({ query, resolve, reject }) => ({
    type: types.SEARCH_LOCATIONS_FOR_COHORT_REQ,
    query,
    resolve,
    reject
});

export const getWakeWords = ({ projectId, resolve, reject }: IGetWakeWordsParam) => ({
    type: types.GET_WAKEWORDS_REQ,
    projectId,
    resolve,
    reject
});

export const saveWakeWord = ({ projectId, wakeWordName, wakeWordId, options, acousticName, resolve, reject }: ISaveWakeWordParam) => ({
    type: types.SAVE_WAKEWORD_REQ,
    projectId,
    wakeWordName,
    wakeWordId,
    options,
    acousticName,
    resolve,
    reject
});

export const deleteWakeWord = ({ projectId, wakeWordId, resolve, reject }: IDeleteWakeWordParam) => ({
    type: types.DELETE_WAKEWORD_REQ,
    projectId,
    wakeWordId,
    resolve,
    reject
});

export interface IGetTransformInfoParam extends IPromiseParam {
    projectId: string,
    environment: Environment,
    transformName: string,
    limit: number,
    offset: number,
    paginationKey: string,
}

export const getTransformInfo = ({ projectId, environment, transformName, limit, offset, paginationKey, resolve, reject }: IGetTransformInfoParam) => ({
    type: types.GET_TRANSFORM_INFO_REQ,
    projectId,
    environment,
    transformName,
    limit,
    offset,
    paginationKey,
    resolve,
    reject
});

export interface ICopyTransformRowParam extends IPromiseParam {
    project: IProject,
    row: ITransformRow,
    transformName: string
    environment: Environment
}

export const copyTransformRow = ({ row, environment, transformName, project, resolve, reject }: ICopyTransformRowParam) => {
    return {
        type: types.COPY_TRANSFORM_ROW_REQ,
        row,
        project,
        transformName,
        environment,
        resolve,
        reject
    };
};

export interface IRunCodeGeneratorParam extends IPromiseParam {
    script: string;
    line: number;
    column: number;
}
export const runCodeGenerator = ({ script, line, column, resolve, reject }: IRunCodeGeneratorParam) => {
    return {
        type: types.RUN_CODE_GENERATOR_REQ,
        script, line, column, resolve, reject
    };
};

export interface ISetScriptsGraphCacheParam {
    project: IProject;
    script: IScript;
    graph: string;
    val: object;
    title: string;
    svg: object;
    engine: string;
}

export const setScriptsGraphCache = ({ project, script, graph, val, title, svg, engine }: ISetScriptsGraphCacheParam) => ({
    type: types.SET_SCRIPTS_GRAPH_CACHE_REQ,
    project,
    script,
    graph,
    val,
    title,
    svg,
    engine
});

export interface IOpenLargeScriptParam {
    scriptId: string;
}
export const openLargeScript = (p: IOpenLargeScriptParam) => {
    return {
        type: types.OPEN_LARGE_SCRIPT_REQ,
        ...p
    }
};

